export const DAY_END = 4; // 4am
